module.exports = __webpack_public_path__ + "static/media/PPT-next-active.18e6c8ff.svg";